const LOGIN_REDIRECT_LOCATION = 'loginRedirectLocation';
const saveCurrentPathForLoginRedirect = (wasUserLoggedIn) => {
  const currentLocation = {
    pathname: window.location.pathname,
    search: window.location.search,
    wasUserLoggedIn,
  };

  if (currentLocation.pathname.includes('login')) {
    return;
  }

  localStorage.setItem(
    LOGIN_REDIRECT_LOCATION,
    JSON.stringify(currentLocation)
  );
};

const completeLoginRedirect = (navigate) => {
  const loggedOutFromLocation = localStorage.getItem(LOGIN_REDIRECT_LOCATION);

  if (loggedOutFromLocation) {
    try {
      const params = JSON.parse(loggedOutFromLocation);
      const pathname = params?.pathname || '';
      const search = params?.search || '';

      navigate(pathname + search, { replace: true });
      localStorage.removeItem(LOGIN_REDIRECT_LOCATION);
    } catch (error) {
      navigate('/', { replace: true });
      localStorage.removeItem(LOGIN_REDIRECT_LOCATION);
    }
  } else {
    navigate('/', { replace: true });
  }
};

const wasRedirectedToLoginBySessionExpiry = () => {
  const storedRedirectLocation = localStorage.getItem(LOGIN_REDIRECT_LOCATION);
  if (storedRedirectLocation) {
    try {
      const storedRedirectLocationData = JSON.parse(storedRedirectLocation);
      return storedRedirectLocationData.wasUserLoggedIn;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export {
  saveCurrentPathForLoginRedirect,
  completeLoginRedirect,
  wasRedirectedToLoginBySessionExpiry,
};
